export default __webpack_public_path__ + "static/media/sportswear.b428feed.jpg";